import React from "react";
import {Heading, HeadingStyle, HeadingElement} from "./Heading";

import "./HeadingWithDescription.scss";

export interface IHeadingWithDescription extends React.HTMLProps<HeadingWithDescription> {
  titleText: string;
  description?: string | null;
  headingElement?: HeadingElement;
  headingStyle?: HeadingStyle;
}

/**
 * Uses `<Heading />` and adds an additional description below
 *
 * @status deprecated
 *
 * @deprecated use plain HTML tags instead
 */
export class HeadingWithDescription extends React.Component<IHeadingWithDescription, {}>{
  static HeadingStyle = HeadingStyle;
  static HeadingElement = HeadingElement;

  render(){
    return (
      <div className="heading-with-description">
        <Heading headingStyle={this.props.headingStyle} headingElement={this.props.headingElement}>{this.props.titleText}</Heading>
        {this.props.description && <div className="heading-with-description-description">{this.props.description}</div>}
      </div>
    );
  }
}
